import type { Persona, PersonasResponse } from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

const PERSONA_LIST_TIMEOUT_MS = 1_500;

export type { Persona };

export async function listPersonas(): Promise<Persona[]> {
  const body = await apiRequest<PersonasResponse>(
    "/personas",
    { next: { revalidate: 3600 } } as RequestInit,
    PERSONA_LIST_TIMEOUT_MS
  );
  return body.personas;
}
